import { z } from 'zod';
import { emailSchema, phoneSchema } from '@/schemas/shared';

/**
 * Company Information Update Schema (Tab 1)
 * Fields that can be updated in the company's basic information
 */
export const updateCompanyInfoSchema = z.object({
  id: z.number(),
  rut: z.string().min(1, 'RUT es requerido'),
  dv: z.string().min(1, 'DV es requerido'),
  name: z.string().min(1, 'Razón social es requerida'),
  fantasyName: z.string().min(1, 'Nombre de fantasía es requerido'),
  address: z.string().min(1, 'Dirección es requerida'),
  addressNumber: z.string().min(1, 'Numeración es requerida'),
  regionId: z.number({ required_error: 'Región es requerida' }),
  communeId: z.number({ required_error: 'Comuna es requerida' }),
  contactName: z.string().min(1, 'Nombre de contacto es requerido'),
  contactEmail: emailSchema,
  contactPhone: phoneSchema,
});

export type UpdateCompanyInfo = z.infer<typeof updateCompanyInfoSchema>;

/**
 * Company Configuration Update Schema (Tab 2)
 * Fields that can be updated in the company's configuration
 */
export const updateCompanyConfigSchema = z
  .object({
    id: z.number(),
    terminateExpiredContracts: z.boolean(),
    estType: z.string(),
    syncWithRex: z.boolean(),
    rexId: z.string(),
    rexUrl: z.string(),
  })
  .superRefine((data, ctx) => {
    // Si syncWithRex está activo, rexId y rexUrl son requeridos
    if (data.syncWithRex) {
      if (!data.rexId || data.rexId.trim().length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'ID Rex es requerido cuando la sincronización está activa',
          path: ['rexId'],
        });
      }
      if (!data.rexUrl || data.rexUrl.trim().length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'URL Rex es requerida cuando la sincronización está activa',
          path: ['rexUrl'],
        });
      }
    }
  });

export type UpdateCompanyConfig = z.infer<typeof updateCompanyConfigSchema>;
